import { ApiDispatcherInterface } from "./types";

export const createApiAction = <R>(
  cb: (dispatch: ApiDispatcherInterface["dispatch"]) => Promise<R>
) => {
  return (dispatch: ApiDispatcherInterface["dispatch"]) => cb(dispatch);
};
